import { Tooltip, withStyles } from "@material-ui/core";

export const LightTooltip = withStyles((theme) => ({
  tooltip: {
    fontSize: 14,
  },
}))(Tooltip);